module.exports = __webpack_public_path__ + "media/images/front/menu_db01-f234ad14725c48c61cb8181591f962fb.jpg";